import React from 'react';

const SelectImage = props => (
  <svg
    width="371"
    height="270"
    viewBox="0 0 371 270"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="_select" transform="translate(0 1)">
        <g
          id="Group"
          transform="translate(48 142)"
          fillRule="nonzero"
          fill="#65C9DB"
        >
          <path
            d="M263.3,123 L0.7,123 L0.7,72.3 C0.7,59.2 11.3,48.6 24.4,48.6 L239.4,48.6 C252.5,48.6 263.1,59.2 263.1,72.3 L263.1,123 L263.3,123 Z"
            id="Shape"
          />
          <path
            d="M220.2,76.1 L43.8,76.1 C37.2,76.1 31.8,70.7 31.8,64.1 L31.8,12.9 C31.8,6.3 37.2,0.9 43.8,0.9 L220.1,0.9 C226.7,0.9 232.1,6.3 232.1,12.9 L232.1,64.1 C232.2,70.7 226.8,76.1 220.2,76.1 Z"
            id="Shape"
          />
        </g>
        <path
          d="M22.1,210.2 C39.6,212.8 39.4,192.6 39.4,192.6 C25.9,193.7 22.6,205.3 21.8,209 C21.5,207.8 21.2,206.7 20.9,205.7 C19,200.5 20.9,193.7 20.9,193.6 C20.9,193.5 20.9,193.3 20.9,193.2 C23.4,192.2 30.1,188.7 29.3,180.1 C29.3,180.1 23.4,181.1 20.7,185 C20.6,183.3 20,181.4 18.3,179.6 C18.3,179.6 16.1,182 15.7,184.9 C14,183.3 11.6,182.1 8.3,181.8 C8.3,181.8 8.2,193.8 18.1,193.5 C17.7,195.3 16.6,200.5 17.9,205.4 C15.4,200.3 10.4,194.4 0.5,193.6 C0.5,193.6 0.3,216.1 19.8,213.2 C20.4,217.1 20.6,221.3 20.5,224.3 L6.4,224.3 L6.4,265 L37,265 L37,224.3 L23.2,224.3 C23.4,220.4 23,214.8 22.1,210.2 Z M19.5,191.1 C19.5,190.9 19.4,190.8 19.3,190.6 C19.3,190.6 19.4,190.5 19.4,190.5 C19.5,190.7 19.5,190.9 19.5,191.1 Z"
          id="Shape"
          fill="#65C9DB"
          fillRule="nonzero"
        />
        <path
          d="M192.4,30.8 C192.4,30.8 195,41 205.2,47.4 C210.9,51 216.3,52.4 219.4,53 L219.4,39.3 C219.4,17.8 201.4,0.3 179.9,0.3 C158.4,0.3 141.5,17.7 141.5,39.3 L141.5,50.2 C151.7,49.6 169.1,47.9 176.5,43.8 C187,38.1 192.4,30.8 192.4,30.8 Z"
          id="Shape"
          fill="#5FC3B5"
          fillRule="nonzero"
        />
        <polygon
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#CBE8E3"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="199 129.6 180.4 158 161.8 129.6 161.8 109.9 199 109.9"
        />
        <path
          d="M255.6,161.2 C255.6,144.7 243.2,131.1 227.3,129.1 C226,128.9 224.6,128.8 223.2,128.8 L199.1,128.8 L180.5,149.3 L162.1,128.4 L136.7,128.4 C135.5,128.4 134.3,128.5 133.2,128.6 C117,130.3 104.3,144.1 104.3,160.8 L104.3,191.9 L116,191.9 L116,267 L244,267 L244,191.9 L255.6,191.9 L255.6,161.2 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#3A3A39"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g
          id="Group"
          transform="translate(90 144)"
          stroke="#636464"
          strokeWidth="2.5"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M159.7,55.3 C161,55.7 162.4,55.5 163.6,54.8 C164.8,54.1 165.7,53 166,51.7 L174.4,21.8 C175.2,19.1 173.6,16.3 170.9,15.5 C168.2,14.7 165.4,16.3 164.6,19 L156.2,48.9 C155.4,51.7 157,54.5 159.7,55.3 Z"
            id="Shape"
            fill="#CBE8E3"
          />
          <path
            d="M19.6,55.3 C18.3,55.7 16.9,55.5 15.7,54.8 C14.5,54.1 13.6,53 13.3,51.7 L4.8,21.9 C4,19.2 5.6,16.4 8.3,15.6 C11,14.8 13.8,16.4 14.6,19.1 L23.1,48.9 C23.9,51.7 22.3,54.5 19.6,55.3 Z"
            id="Shape"
            fill="#CBE8E3"
          />
          <rect
            id="Rectangle-path"
            fill="#FFF"
            x="11.9"
            y=".5"
            width="156"
            height="90.8"
          />
          <g id="Shape" fill="#CBE8E3">
            <path
              d="M17.5,15.7 C17.5,18.5 15.3,20.8 12.5,20.9 L6.2,21 C3.4,21 1.1,18.8 1,16 C1,13.2 3.2,10.9 6,10.8 L12.3,10.7 C15.2,10.6 17.5,12.9 17.5,15.7 Z"
              transform="translate(8 50)"
            />
            <path
              d="M17.4,5.4 C17.4,8.2 15.2,10.5 12.4,10.6 L5.4,10.7 C2.6,10.7 0.3,8.5 0.2,5.7 C0.2,2.9 2.4,0.6 5.2,0.5 L12.2,0.4 C15,0.3 17.3,2.5 17.4,5.4 Z"
              transform="translate(8 50)"
            />
            <path
              d="M24.5,15.1 C24.5,17.9 22.3,20.2 19.5,20.3 L10.2,20.4 C7.4,20.4 5.1,18.2 5,15.4 C5,12.6 7.2,10.3 10,10.2 L19.3,10.1 C22.2,10 24.5,12.3 24.5,15.1 Z"
              transform="translate(0 30)"
            />
            <path
              d="M13.9,5.2 C13.9,8 11.7,10.3 8.9,10.4 L5.3,10.5 C2.5,10.5 0.2,8.3 0.1,5.5 C0.1,2.7 2.3,0.4 5.1,0.3 L8.7,0.2 C11.6,0.1 13.9,2.4 13.9,5.2 Z"
              transform="translate(0 30)"
            />
          </g>
          <g id="Shape" fill="#CBE8E3">
            <path
              d="M0.5,15.7 C0.5,18.5 2.7,20.8 5.5,20.9 L11.8,21 C14.6,21 16.9,18.8 17,16 C17,13.2 14.8,10.9 12,10.8 L5.7,10.7 C2.8,10.6 0.5,12.9 0.5,15.7 Z"
              transform="translate(154 50)"
            />
            <path
              d="M0.6,5.4 C0.6,8.2 2.8,10.5 5.6,10.6 L12.6,10.7 C15.4,10.7 17.7,8.5 17.8,5.7 C17.8,2.9 15.6,0.6 12.8,0.5 L5.8,0.4 C3,0.3 0.7,2.5 0.6,5.4 Z"
              transform="translate(154 50)"
            />
            <path
              d="M1.5,15.1 C1.5,17.9 3.7,20.2 6.5,20.3 L15.8,20.4 C18.6,20.4 20.9,18.2 21,15.4 C21,12.6 18.8,10.3 16,10.2 L6.7,10.1 C3.8,10 1.5,12.3 1.5,15.1 Z"
              transform="translate(154 30)"
            />
            <path
              d="M12.1,5.2 C12.1,8 14.3,10.3 17.1,10.4 L20.7,10.5 C23.5,10.5 25.8,8.3 25.9,5.5 C25.9,2.7 23.7,0.4 20.9,0.3 L17.3,0.2 C14.4,0.1 12.1,2.4 12.1,5.2 Z"
              transform="translate(154 30)"
            />
          </g>
        </g>
        <path
          d="M220,58.6 C219.8,58.6 219.6,58.6 219.4,58.6 L219.4,53.2 C216.3,52.7 211.5,51.2 205.8,47.6 C195.7,41.2 192.5,31 192.5,31 C192.5,31 187.7,38.3 177.1,44.1 C169.7,48.1 151.7,49.8 141.5,50.5 L141.5,58.6 C141.3,58.6 141.1,58.6 140.9,58.6 C137.5,58.6 134.8,61.3 134.8,64.7 L134.8,75.1 C134.8,78.5 137.5,81.2 140.9,81.2 C141.2,81.2 141.4,81.2 141.7,81.1 C143.4,101.1 160.1,116.7 180.5,116.7 C200.9,116.7 217.6,101 219.3,81.1 C219.6,81.1 219.8,81.2 220.1,81.2 C223.5,81.2 226.2,78.5 226.2,75.1 L226.2,64.7 C226.2,61.3 223.4,58.6 220,58.6 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#CBE8E3"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M193.7,94.8 C186.5,102.1 174.7,102 167.3,95 C165.4,93.2 164,91.1 164,88.9 L164,88.9 L196.7,88.9 L196.7,88.9 C196.7,91.1 195.5,93.1 193.7,94.8 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#5FC3B5"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M159.1,67.9 C165.3,63.7 170.8,67.9 170.8,67.9"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M190.2,67.9 C196.4,63.7 201.9,67.9 201.9,67.9"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M213.2,52.2 L215.8,52.4 C215,52.2 214.2,51.9 213.3,51.6 C213.2,51.8 213.2,52 213.2,52.2 Z"
          id="Shape"
          fill="#CBE8E3"
          fillRule="nonzero"
        />
        <path
          d="M219.4,53.2 L219.4,52.6 L215.8,52.3 C217.2,52.8 218.4,53.1 219.4,53.2 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M180.4,0.6 C158.9,0.6 142,18 142,39.6 L142,49.9 L147.9,49.9 C143.5,-9.7 219.4,-6.1 212.7,51.5 C213.6,51.8 215.4,52.1 216.2,52.3 L219.8,52.6 L219.8,39.6 C219.9,18.1 201.9,0.6 180.4,0.6 Z"
          id="Shape"
          fill="#CBE8E3"
          fillRule="nonzero"
        />
        <path
          d="M192.5,31.1 C192.5,31.1 195.1,41.3 205.3,47.7 C211,51.3 216.4,52.7 219.5,53.3 L219.5,39.6 C219.5,18.1 201.5,0.6 180,0.6 C158.5,0.6 141.6,18 141.6,39.6 L141.6,50.5 C151.8,49.9 169.2,48.2 176.6,44.1 C187.1,38.4 192.5,31.1 192.5,31.1 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M211.9,175.4 L180.9,215.9 C180.5,216.4 179.9,216.7 179.3,216.8 L179.1,216.8 C178.4,216.8 177.8,216.5 177.3,216 L162.6,200.2 C161.9,199.4 161.8,198.3 162.4,197.4 C163,196.6 164.1,196.2 165.1,196.5 L178.3,200.8 L208.5,172.4 C209.4,171.6 210.8,171.6 211.7,172.3 C212.4,173.1 212.6,174.5 211.9,175.4 Z"
          id="Shape"
          fill="#5FC3B5"
          fillRule="nonzero"
        />
        <path
          d="M308.9,129.9 C317,131.2 325.3,131.9 333.5,132.1 L333.5,136.3 C333.5,137 334.1,137.6 334.8,137.6 L336.4,137.6 L337.2,265 L342.3,265 L341.5,137.6 L343.2,137.6 C343.9,137.5 344.4,136.9 344.4,136.2 L344.4,132.1 C352.6,131.8 360.8,130.9 369,129.6 C369.4,129.5 369.9,129.3 370.1,128.9 C370.4,128.5 370.5,128.1 370.4,127.6 L362.9,84.9 C362.7,83.8 361.8,83 360.7,82.9 C357,82.7 347.6,82.2 338.7,82.3 C329.8,82.4 320.3,82.9 316.6,83.2 C315.5,83.2 314.6,84.1 314.5,85.1 L307.4,128.1 C307.4,128.1 307.4,128.1 307.4,128.1 C307.4,129 308,129.8 308.9,129.9 Z"
          id="Shape"
          fill="#65C9DB"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);
export default SelectImage;
